import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import { LEFT_MENU_REVEAL_TARGETS } from "../../../shared/utility/use-reveal-notifications";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import LeftMenuRevealIcon from "./left-menu-reveal-icon";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IImageLibraryButtonState {}

export interface ILanguageButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class LanguageButton extends PureSdComponent<ILanguageButtonProps & IWithSDProps, IImageLibraryButtonState> {
  constructor(props: ILanguageButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Language);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Language);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.LanguageButton) === Visibility.Visible && (
          <LeftMenuRevealIcon targets={LEFT_MENU_REVEAL_TARGETS.language}>
            <KuikaButton
              data-testid="leftMenuLanguageTabButton"
              data-onboarding-id="left_menu_language"
              type="tertiary"
              size="md"
              isIcon
              color="neutral"
              active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Language)}
              onClick={this.handleClick}
            >
              <KuikaSvg type="sidebar-icons" name="language" width={18} height={18} pointer />
            </KuikaButton>
          </LeftMenuRevealIcon>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}
const languageButton = withSD<ILanguageButtonProps>(LanguageButton);
export { languageButton as LanguageButton };
